import { Pipe, PipeTransform } from '@angular/core';
import { addMinutes } from 'date-fns';

import { legacyParse } from '@date-fns/upgrade/v2';
import { formatDate } from '@shared/timetracking-filter/date.utility';

@Pipe({
  name: 'formatPeriod'
})
export class FormatPeriodPipe implements PipeTransform {
  transform(value: any, ...args): any {
    const offset = new Date(value).getTimezoneOffset();
    const val = addMinutes(legacyParse(new Date(value)), -offset);

    return formatDate(val, 'HH:mm');
  }
}
